module.exports = __webpack_public_path__ + "static/media/9.9f25cf23.mp3";